export default __webpack_public_path__ + "static/hand_drawing-7803d7eee232919025ccde1ea21359f1.png";